module.exports = __webpack_public_path__ + "static/media/wind_drifted_snow.7cfefa3f.svg";